import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";

// Migrate default theme color in localStorage to match the brand color
if (localStorage.getItem("default_color") === "#7366ff" || !localStorage.getItem("default_color")) {
  localStorage.setItem("default_color", "#d3178a");
}
if (localStorage.getItem("secondary_color") === "#f73164" || !localStorage.getItem("secondary_color")) {
  localStorage.setItem("secondary_color", "#ff3364");
}


const Root = () => {
  return (
    <div className="App">
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
